module.exports = __webpack_public_path__ + "img/casa.6d44fb8a.png";